/*
创建者 魏强(2018.2.7)
商品列表页面
*/
<template>
  <div id="goods-list-page">
    <div class="breadcrumb wrapper" style="line-height:30px;">
      <span>
        <router-link to="/">首页</router-link>
      </span>
      <span class="arrow">&gt;</span>
      <span>搜索结果</span>
      <span class="arrow">&gt;</span>
      <span>{{this.keywords}}</span>
    </div>
    <div class="container wrapper clearfix">
      <!-- 左侧菜单 -->
      <lefe-tree v-if="aggs" :data="aggs" @clickType="searchResult"></lefe-tree>

      <!-- 右侧商品 -->
      <div class="right" id="result">
        <div class="shop_con_list" id="main-nav-holder">
          <nav class="sort-bar" id="main-nav">
            <input type="hidden" value="desc" name="order">
            <div class="sortbar-array"> 排序方式：
              <ul>
                <li :class="{selected:search_type===0}">
                  <a href="javascript:void(0)" class="nobg" @click="searchByType(0)">
                    默认<i></i>
                  </a>
                </li>
                <li :class="{selected:search_type===1}">
                  <a href="javascript:void(0)" @click="searchByType(1)" class="nobg">
                    销量<i></i>
                  </a>
                </li>
                <li :class="{selected:search_type===2}">
                  <a href="javascript:void(0)" @click="searchByType(2)" :class="order"
                    :title="order=='desc'?'点击按价格从低到高排序':'点击按价格从高到低排序'">
                    价格<i></i>
                  </a>
                </li>
              </ul>
              <label for="local" style="vertical-align: middle;">
                <input v-model="goods_local" type="checkbox" @change="changePage(1)">
                只显示本地商户
              </label>
            </div>
          </nav>
          <p v-if="!this.loading&&this.list.length==0"
            style="color:red;font-size:20px;text-align:center;margin-top:20px;">
            抱歉,暂无此类商品!
          </p>
          <right-goods :data="list"></right-goods>
          <div v-show="total>0" class="page-wrapper">
            <Page :total="total" :current="page" :page-size="pageSize" show-elevator show-total @on-change="changePage">
            </Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lefeTree from './module-left-tree.vue';
import rightGoods from './module-right-goods.vue';
import { goodsSearch, goodsSearchTree } from 'api/home';
export default {
  components: {
    lefeTree, rightGoods
  },
  data() {
    return {
      aggs: '',
      list: [],
      keywords: "",
      vouchers_status: 0,
      search_type: 0,
      goods_local: false,
      order: 'desc',
      priceOrderCount: 1,
      priceOrder: 'desc',
      page: 1,
      pageSize: 12,
      loading: false,
      query: {},
      total: 0,
      source_flag: '',
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "商品列表" || to.name === "直供专区" || to.name === "首购专区") {
        this.keywords = this.$route.query.catname || this.$route.query.keywords;
        this.vouchers_status = this.$route.query.vouchers_status;
        this.page = 1;
        this.list = [];
        this.query = this.$route.query;
        if (to.name === "直供专区" || this.$route.path === '/supply-chain-list') {
          this.source_flag = '2';
        } else if (to.name === "首购专区" || this.$route.path === '/first-buy-list') {
          this.source_flag = '4';
        } else {
          this.source_flag = '';
        }
        this.order = 'desc';
        this.search_type = 0;
        this.priceOrderCount = 1;
        this.fetchData();
      }
    }
  },
  created() {
    this.keywords = this.$route.query.catname || this.$route.query.keywords;
    this.vouchers_status = this.$route.query.vouchers_status;
    this.query = this.$route.query;
    if (this.$route.path === '/supply-chain-list') {
      this.source_flag = '2';
    }
    if (this.$route.path === '/first-buy-list') {
      this.source_flag = '4';
    }

    this.fetchData();

  },
  methods: {
    changePage(index) {
      this.page = index;
      this.fetchData();
    },
    fetchData() {
      if (!this.loading) {
        // this.total = 0;
        this.loading = true;
        //          let query = this.$route.query;
        let params = {
          ...this.query,
          catId: this.query.cat_id || '',
          searchType: this.search_type,
          vouchers_status: this.vouchers_status,
          local: this.goods_local,
          pageNo: this.page,
          pageSize: this.pageSize,
          namekeyword: this.query.keywords,
          order: this.order,
        };
        if (this.source_flag) params.sourceFlag = this.source_flag;

        //order:"asc" 排序 asc 升序 desc 降序
        //this.page,this.pageSize,this.search_type,this.keywords,this.order;
        goodsSearch(params).then(json => {
          if (json.resCode == 1) {
            this.loading = false;
            let data = json.data;
            this.list = data.pageResult.data;
            this.total = data.totalCount;

          } else {
            console.log("获取商品列表数据错误！")
          }
        });

        goodsSearchTree(params).then(json => {
          if (json.resCode == 1) {
            this.loading = false;
            let data = json.data;
            this.aggs = data.pageResult.aggs;
          } else {
            console.log("获取商品书数据错误！")
          }
        });
      }
    },
    // 点击左边分类回调，仅更新右侧结果列表
    getResultData() {
      if (!this.loading) {
        // this.total = 0;
        this.loading = true;
        let params = {
          ...this.query,
          catId: this.query.cat_id || '',
          searchType: this.search_type,
          vouchers_status: this.vouchers_status,
          local: this.goods_local,
          pageNo: this.page,
          pageSize: this.pageSize,
          namekeyword: this.query.keywords,
          order: this.order,
        };
        if (this.source_flag) params.sourceFlag = this.source_flag;
        //order:"asc" 排序 asc 升序 desc 降序
        //this.page,this.pageSize,this.search_type,this.keywords,this.order;
        goodsSearch(params).then(json => {
          if (json.resCode === 1) {
            this.loading = false;
            let data = json.data;
            this.list = data.pageResult.data;
            this.total = data.totalCount;

          } else {
            console.log("获取商品列表数据错误！")
          }
        });
      }
    },
    searchResult(query) {
      this.page = 1;
      this.query = query;
      this.getResultData()
    },
    searchByType(type) {
      if (!this.loading) {
        this.list = [];
        this.search_type = type;
        this.page = 1;

        if (type === 2) {
          // 第一次点击不排序
          if (this.priceOrderCount % 2 === 0) {
            this.order = 'desc';
          } else {
            this.order = 'asc';
          }
          this.priceOrderCount++;

        } else {
          this.order = 'desc';
        }
        this.getResultData();
      }
    }
  },
  // 销毁组件，返回刷新
  deactivated() {
    this.$destroy()
  },
}
</script>
<style scoped>
#goods-list-page .wrapper {
  width: 1200px !important;
  margin: 0 auto;
}

.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// goods-list.vue?1ab20b38